/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespNullSearchResultsHeader_searchBrowse$ref = any;
type SbSharedFollowSearchProvider_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespNullSearchResults_searchBrowse$ref: FragmentReference;
export type SbRespNullSearchResults_searchBrowse = {|
  +$fragmentRefs: SbSharedFollowSearchProvider_searchBrowse$ref & SbRespNullSearchResultsHeader_searchBrowse$ref,
  +$refType: SbRespNullSearchResults_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResultsHeader_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd3f0cd41bd95107463b04739aa3f6496';
module.exports = node;
